import { render, staticRenderFns } from "./ComponentInspector.vue?vue&type=template&id=33d32a5f&scoped=true&"
import script from "./ComponentInspector.vue?vue&type=script&lang=js&"
export * from "./ComponentInspector.vue?vue&type=script&lang=js&"
import style0 from "./ComponentInspector.vue?vue&type=style&index=0&id=33d32a5f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d32a5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d32a5f')) {
      api.createRecord('33d32a5f', component.options)
    } else {
      api.reload('33d32a5f', component.options)
    }
    module.hot.accept("./ComponentInspector.vue?vue&type=template&id=33d32a5f&scoped=true&", function () {
      api.rerender('33d32a5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/components/ComponentInspector.vue"
export default component.exports